import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'classlist-polyfill'

window.addEventListener('scroll', () => {
  let scrollTop = window.scrollY || document.documentElement.scrollTop || 0
  let heroHeight = (document.querySelector('.page-homepage')) ? window.innerHeight : ((window.innerWidth > 767) ? 450 : 200)

  if (!document.querySelector('.single-blog-page')) {
    document.getElementById('navigation').classList[scrollTop > 0 ? 'add' : 'remove']('active')
  }

  let edgeOffset = 0

  if (/Edge\/\d./i.test(navigator.userAgent)) {
    console.log('This is Microsoft Edge')
    // edgeOffset = 10
  }

  if (document.querySelector('.page.page-what-we-offer')) {
    if (scrollTop > heroHeight - document.getElementById('navigation').offsetHeight - edgeOffset) {
      document.getElementById('offers-navigation').classList.add('fixed')
      document.getElementById('offers-navigation').style.top = `${document.getElementById('navigation').offsetHeight}px`

      document.getElementById('offers-menu-shadow').style.height = `${document.getElementById('offers-navigation').offsetHeight}px`

    } else {
      document.getElementById('offers-navigation').classList.remove('fixed')
      document.getElementById('offers-navigation').style.top = `auto`

      document.getElementById('offers-menu-shadow').style.height = `0px`
    }
  }

  if (document.querySelector('.page.page-shop')) {
    if (scrollTop > heroHeight - document.getElementById('navigation').offsetHeight - edgeOffset) {
      document.getElementById('filters-navigation').classList.add('fixed')
      document.getElementById('filters-navigation').style.top = `${document.getElementById('navigation').offsetHeight}px`

      document.getElementById('filters-menu-shadow').style.height = `${document.getElementById('filters-navigation').offsetHeight}px`

    } else {
      document.getElementById('filters-navigation').classList.remove('fixed')
      document.getElementById('filters-navigation').style.top = `auto`

      document.getElementById('filters-menu-shadow').style.height = `0px`
    }
  }
})

document.querySelector('#open-sidebar').addEventListener('click', () => {
  document.querySelector('body').classList.add('active')
})

document.querySelector('#overlay').addEventListener('click', () => {
  document.querySelector('body').classList.remove('active')
})

document.querySelector('#close-sidebar').addEventListener('click', () => {
  document.querySelector('body').classList.remove('active')
})

if (document.querySelector('#toggle-offers-menu')) {
  document.querySelector('#toggle-offers-menu').addEventListener('click', () => {
    document.querySelector('#toggle-offers-menu').classList.toggle('active')
    document.querySelector('.flex-offers-navigation').classList.toggle('active')
  })
}

if (document.querySelector('#toggle-filters-menu')) {
  document.querySelector('#toggle-filters-menu').addEventListener('click', () => {
    document.querySelector('#toggle-filters-menu').classList.toggle('active')
    document.querySelector('.flex-filters-navigation').classList.toggle('active')
  })
}

document.querySelectorAll('.shop-card').forEach((element, index) => {
  let currentShopCardImages = element.querySelectorAll('.shop-card-header img')
  currentShopCardImages.forEach((image, index) => {
    (index !== 0) ? image.classList.add('hidden') : null
  })

  let dropdowns = element.querySelectorAll('select')
  if (dropdowns.length) {
    dropdowns[0].addEventListener('change', (dropdown) => {
      currentShopCardImages.forEach((image, index) => {
        image.classList.remove('hidden')
      })

      currentShopCardImages.forEach((image, index) => {
        (index !== dropdown.target.selectedIndex) ? image.classList.add('hidden') : null
      })
    })
  }

  element.querySelectorAll('input[type="image"]').forEach((input) => {
    input.src = `${templateUrl}/assets/button_paypal.svg`
  })
})

const iframe = '<iframe src="https://www.youtube.com/embed/7reUFPAipvw?controls=1" class="full-width"></iframe>'

if (document.querySelector('.page.page-homepage')) {
  let newsLinkString = document.querySelector('.wp-menu-navigation > div > ul > li:nth-of-type(1) > a').href
  document.querySelector('#news-link').href = newsLinkString

  let ourOffersLinkString = document.querySelector('.wp-menu-navigation > div > ul > li:nth-of-type(3) > a').href
  document.querySelector('#all-offers-link').href = ourOffersLinkString

  document.querySelectorAll('.flex-what-we-offer [data-slug]').forEach(element => {
    element.href = `${ourOffersLinkString}#${element.dataset.slug}`
  })

  const iframe = '<iframe src="https://www.youtube.com/embed/7reUFPAipvw?controls=1" class="full-width"></iframe>'

  document.querySelector('#homepage-open-video-modal').addEventListener('click', () => {
    document.querySelector('#modal-video').classList.add('active')
    document.querySelector('#modal-video  .content').innerHTML = iframe
  })

  document.querySelector('#modal-video-close').addEventListener('click', () => {
    document.querySelector('#modal-video').classList.remove('active')
    document.querySelector('#modal-video .content').innerHTML = ''
  })

  document.querySelectorAll('#gizmo-map-points #dubrovnik, #gizmo-map-points #rijeka, #gizmo-map-points #zagreb, #gizmo-map-points #sarajevo').forEach((city) => {
    city.addEventListener('click', (e) => {
      let currentModalTitle = e.target.dataset.title

      document.querySelector(`#modal-map .header .modal-title`).innerHTML = ''
      
      document.querySelectorAll(`#modal-map .content .modal-gallery`).forEach(gallery => {
        gallery.classList.add('hidden')
      })

      document.querySelector('#modal-map').classList.add('active')

      document.querySelector(`#modal-map .header .modal-title`).innerHTML = currentModalTitle
      document.querySelector(`#modal-map .content [data-modal-parent="${e.target.id}"]`).classList.remove('hidden')
    })
  })

  document.querySelector('#modal-map-close').addEventListener('click', () => {
    document.querySelector('#modal-map').classList.remove('active')
  })
}

if (document.querySelector('.page.page-blog')) {
  const prevLink = (document.querySelector('#pagination-hidden-prev a')) ? document.querySelector('#pagination-hidden-prev a').href : '#'
  const nextLink = (document.querySelector('#pagination-hidden-next a')) ? document.querySelector('#pagination-hidden-next a').href : '#'

  document.querySelector('#pagination-prev').href = prevLink
  document.querySelector('#pagination-next').href = nextLink

  if (document.querySelector('#pagination-prev').href.includes('#')) document.querySelector('#pagination-prev').remove()
  if (document.querySelector('#pagination-next').href.includes('#')) document.querySelector('#pagination-next').remove()
}

const friction = 1 / 150
if (document.querySelector('.js-hero-mouse-position')) {
  document.querySelector('.hero').addEventListener('mousemove', (e) => {
    let mouseX = e.clientX
    let mouseY = e.clientY
    animateHeroBackBackground(mouseX, mouseY)
  })
}
function animateHeroBackBackground (mouseX, mouseY) {
  let x = Math.floor(mouseX * friction)
  let y = Math.floor(mouseY * friction)
  if (document.querySelector('.hero-image')) {
    document.querySelector('.hero-image').style.msTransform = `translateX(-50%) translateX(-${x}px) translateY(40%) translateY(+${y}px)`
    document.querySelector('.hero-image').style.webkitTransform = `translateX(-50%) translateX(-${x}px) translateY(40%) translateY(+${y}px)`
    document.querySelector('.hero-image').style.transform = `translateX(-50%) translateX(-${x}px) translateY(40%) translateY(+${y}px)`
    // document.querySelector('.hero-image').style.transform = `translate(calc(-50% - ${x}px), calc(40% + ${y}px))`
  }

  window.requestAnimationFrame(animateHeroBackBackground)
}
